import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { ContentEntryService } from '@services/content-entries/content-entry.service';
import { MenuItemService } from '@services/menu-items/menu-item.service';
import * as _ from 'lodash';
import { ImportService } from '@services/imports/import.service';
import { PageAction } from '../../components/page-actions/page-actions.component';

@Component({
    selector: 'app-import-data-explorer',
    templateUrl: './import-data-explorer.component.html',
    styleUrls: ['./import-data-explorer.component.scss'],
    providers: [ContentEntryService, MenuItemService, ImportService],
    standalone: false
})
export class ImportDataExplorerComponent implements OnInit {
  public compositions: any[];
  public menuItems: Models.MenuItem[] = [];
  public menuItemsById = {};
  public parentMenuItems: Models.MenuItem[] = [];
  public finalMenuItemElement = [];
  public contentEntries: Models.ContentEntry[] = [];
  public contentEntriesById = {};
  public parentEntries: Models.ContentEntry[] = [];
  public isLoading = true;
  public title = 'Import: ';
  public pageActions = [
    new PageAction({
      icon: 'subdirectory_arrow_left', title: 'Go to Import', callback: () => { this.router.navigate(['imports/', this.route.snapshot.params['id']]); }
    }),
    new PageAction({
      icon: 'refresh', title: 'Refresh',
      callback: () => {
        this.menuItems = [];
        this.contentEntries = [];
        this.contentEntriesById = [];
        this.parentEntries = [];
        this.parentMenuItems = [];
        this.menuItemsById = [];
        this.ngOnInit();
      }
    })
  ];

  constructor(
    private route: ActivatedRoute, private entryService: ContentEntryService, private itemService: MenuItemService, private importService: ImportService, private router: Router
  ) {}

  async ngOnInit() {
    this.isLoading = true;
    await this.loadData();
    for (const entry of this.contentEntries) {
      this.contentEntriesById[entry._id] = entry;
    }

    for (const entry of this.contentEntries.filter(e => !!e?.related?.entries?.length)) {
      const newEntry = _.clone(entry) as any;
      newEntry.related = _.clone(entry.related) as any;
      newEntry.related.entries = [];
      for (const related of entry.related.entries) {
        newEntry.related.entries.push(this.contentEntriesById[related.id]);
      }
      this.contentEntriesById[newEntry._id] = newEntry;
    }

    for (const entry of this.contentEntries.filter(e => !!e?.related?.entries?.length)) {
      this.parentEntries.push(this.contentEntriesById[entry._id]);
    }

    for (const menuItem of this.menuItems) {
      const item = menuItem as any;
      item.entry = this.contentEntriesById[item.entry];
      this.menuItemsById[item._id] = item;
      if (menuItem.children.length > 0) {
        this.parentMenuItems.push(menuItem);
      }
    }

    const newParentItems = [];
    for (const item of this.parentMenuItems) {
      const newItem = _.clone(item) as any;
      newItem.children = [];
      for (const child of item.children) {
        newItem.children.push(this.menuItemsById[child.id]);
      }
      newParentItems.push(newItem);
    }

    for (let i = 0; i < newParentItems.length; i++) {
      for (let y = 0; y < newParentItems.length; y++) {
        for (let x = 0; x < newParentItems[i].children.length; x++) {
          if (newParentItems[i].children[x] && newParentItems[i].children[x]._id === newParentItems[y]._id) {
            newParentItems[i].children[x] = newParentItems[y];
            newParentItems.splice(y, 1);
            y--;
            i--;
            break;
          }
        }
      }
    }

    this.finalMenuItemElement = newParentItems;
    this.isLoading = false;
    const importResult = await this.importService.get(this.route.snapshot.params['id']);
    this.title = this.title + importResult.title;
  }

  async loadData(skip = 0): Promise<any> {
    const menuItems = await this.itemService.find(skip, 100, { importId: this.route.snapshot.params['id'] });
    for (const item of menuItems?.data || []) {
      const menuItem = new Models.MenuItem();
      menuItem.populateFromJSON(item);
      this.menuItems.push(menuItem);
    }
    const entries = await this.entryService.find(skip, 100, { importId: this.route.snapshot.params['id'] });
    for (const entry of entries.data) {
      const newEntry = new Models.ContentEntry();
      newEntry.populateFromJSON(entry);
      this.contentEntries.push(newEntry);
    }
    return (menuItems.total > skip + 100 || entries.total > skip + 100) ? this.loadData(skip + 100) : true;
  }
}
